var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"self",staticClass:"tabs",attrs:{"data-dusk":"tab-group","id":_vm.id}},[_c('div',{staticClass:"tabs-row"},[_vm._t("default",null,{"goToTab":_vm.goToTab})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }